import React from "react";
import style from "./CarInfo.module.scss";

const DetailItem = ({ label, value }) => {
  return (
    <div className={style.detailItem}>
      <span className={style.label}>{label}:</span>
      <span className={style.value}>{value || "Не указан"}</span>
    </div>
  );
};

export default DetailItem;
